/**
 * Values shared by the server half of OIDC login (./server.ts) and the client
 * half (./session.ts, ./components.tsx, ../providers/oidc.ts).
 *
 * Kept free of "use client" and of any import so both halves can pull from it
 * without dragging the other's dependencies along.
 */

/**
 * Where Auth.js is mounted, NOT its default /api/auth.
 *
 * Both dashboards rewrite every /api/* request to their backend (ctrl-api for
 * dash-enterprise, the console API for dash), so auth routes under /api would
 * be proxied away and never reach the app. The callback path is therefore
 * `${AUTH_BASE_PATH}/callback/<provider id>`, which is what must be registered
 * as a redirect URI on the identity provider's client.
 */
export const AUTH_BASE_PATH = "/auth";

/**
 * Marker set on the token when refresh has failed irrecoverably.
 *
 * The session object still exists at that point — Auth.js has no way to delete
 * a cookie from inside the jwt callback — so without this the user sits on a
 * dashboard where every request 401s and nothing prompts them to sign in
 * again. The client treats a session carrying this as signed out.
 */
export const REFRESH_ERROR = "RefreshTokenError";

/** Scope requested at sign-in unless the caller overrides it. */
export const DEFAULT_SCOPE = "openid email profile";
